// Sky Basket brand constants and site config
export const BRAND = {
  name: "Sky Basket",
  fullName: "Sky Basket Stationery & Gifts",
  tagline: "A curated space for timeless stationery and paper goods.",
  logo:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_collage-pdf-builder/artifacts/5c5z2sml_sky.jpg",
  colors: {
    primary: "#299fe0", // Sky blue
    accent: "#cb05a5", // Magenta pink
    white: "#ffffff",
    ink: "#0f172a",
    softInk: "#334155",
    hairline: "#e5e7eb",
    canvas: "#f8fafc",
  },
};

export const CONTACT = {
  address:
    "Booth No. 20, Pocket 4 Phase 2, Omaxe, beside Gurudwara, New Chandigarh, Punjab 140901",
  phone: "098052 68169",
  phoneDial: "+919805268169",
  email: "weareskybasket@gmail.com",
  whatsappNumber: "919805268169",
  instagramHandle: "sky.basket.stationery",
  instagramUrl: "https://www.instagram.com/sky.basket.stationery/",
  facebookUrl: "https://www.facebook.com/",
  mapsUrl: "https://share.google/HqnuwfsCcZK6N9o2R",
  mapsEmbedQuery:
    "Sky+Basket+Stationery+Gifts+Booth+20+Pocket+4+Phase+2+Omaxe+New+Chandigarh+Punjab",
  hoursOpen: "10:00 AM – 9:00 PM",
  lunchBreak: "1:30 PM – 4:00 PM",
  openDays: "Open daily",
};

export const WA_MESSAGES = {
  header:
    "Hi! I visited your website and would like to know more about your stationery collection.",
  floating:
    "Hi! I saw your collection on the website and wanted to check if [Item Name] is currently in stock at the store today.",
};

// Instagram post URLs. Replace with real permalinks from
// https://www.instagram.com/sky.basket.stationery/
export const INSTAGRAM_POSTS = [
  {
    url: "https://www.instagram.com/sky.basket.stationery/",
    image:
      "https://images.unsplash.com/photo-1519682337058-a94d519337bc?auto=format&fit=crop&w=800&q=80",
    caption: "Fresh notebook drop",
  },
  {
    url: "https://www.instagram.com/sky.basket.stationery/",
    image:
      "https://images.unsplash.com/photo-1544816155-12df9643f363?auto=format&fit=crop&w=800&q=80",
    caption: "Fountain pen love",
  },
  {
    url: "https://www.instagram.com/sky.basket.stationery/",
    image:
      "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=800&q=80",
    caption: "Journal spread",
  },
  {
    url: "https://www.instagram.com/sky.basket.stationery/",
    image:
      "https://images.unsplash.com/photo-1517971129774-8a2b38fa128e?auto=format&fit=crop&w=800&q=80",
    caption: "Desk of the day",
  },
  {
    url: "https://www.instagram.com/sky.basket.stationery/",
    image:
      "https://images.unsplash.com/photo-1600693725395-a1ea3e9d4691?auto=format&fit=crop&w=800&q=80",
    caption: "Wax seals arrived",
  },
  {
    url: "https://www.instagram.com/sky.basket.stationery/",
    image:
      "https://images.unsplash.com/photo-1512446733611-9099a758e63c?auto=format&fit=crop&w=800&q=80",
    caption: "Gift wrap season",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=1920&q=80";

export const LATEST_COLLECTION_IMAGE =
  "https://images.unsplash.com/photo-1471107340929-a87cd0f5b5f3?auto=format&fit=crop&w=1600&q=80";

export const CATEGORIES = [
  {
    id: "journals",
    icon: "📒",
    title: "Journals & Planners",
    desc: "Notebooks, sketchbooks, diaries and planners for every mood.",
    image:
      "https://images.unsplash.com/photo-1519682337058-a94d519337bc?auto=format&fit=crop&w=1000&q=80",
    items: ["Notebooks", "Sketchbooks", "Diaries", "Planners"],
  },
  {
    id: "writing",
    icon: "✒️",
    title: "Fine Writing",
    desc: "Imported gel pens, fountain pens, calligraphy tools and premium desk accessories.",
    image:
      "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=1000&q=80",
    items: ["Imported gel pens", "Fountain pens", "Calligraphy", "Desk accessories"],
  },
  {
    id: "gifts",
    icon: "🎁",
    title: "Gifts & Wrapping",
    desc: "Greeting cards, gift wraps, wax seals, decorative papers and stamps.",
    image:
      "https://images.unsplash.com/photo-1512909006721-3d6018887383?auto=format&fit=crop&w=1000&q=80",
    items: ["Greeting cards", "Gift wraps", "Wax seals", "Decorative papers", "Stamps"],
  },
  {
    id: "desk",
    icon: "🖇",
    title: "Desk Essentials",
    desc: "Sticky notes, organizers, paper clips, desk trays and tape dispensers.",
    image:
      "https://images.unsplash.com/photo-1587145820266-a5951ee6f620?auto=format&fit=crop&w=1000&q=80",
    items: ["Sticky notes", "Organizers", "Paper clips", "Desk trays", "Tape dispensers"],
  },
];
